/* vuex状态 */
import Vue from "vue";
import Vuex from "vuex";
import workflow from "@/views/workflow/store/index";
Vue.use(Vuex);
const reg_obj = /^{[\s\S]*}$/;
const _user_info = window.localStorage.getItem("__USER__INFO");
const _user_department = window.localStorage.getItem("__USER__DEPARTMENT");
const _auth_menu = window.localStorage.getItem("__AUTH__MENU");
const _cas_info = window.localStorage.getItem("__CAS__INFO");
const _logo_default_config = JSON.stringify({
  logo: null,
  iocn: null,
  backend: { font: "", title: "" },
  front: { title: "" },
});
const state = {
  /* state 参数命名前缀stt_
   * 示例：stt_onClickShow: true
   */
  stt_noticeShow: parseInt(window.sessionStorage.getItem("noticeShow") || 0), //消息页面显示
  stt_noticeParams: {}, //消息处理的参数
  stt_globalSearchShow: false, //全局搜索页面显示
  stt_globalSearchKeyword: "", //全局搜索关键词
  stt_userInfo: JSON.parse(reg_obj.test(_user_info) ? _user_info : "{}"), //用户信息
  stt_userDepartment: JSON.parse(_user_department || "[]"), //用户部门
  stt_authMenu: JSON.parse(_auth_menu || "[]"), //菜单
  stt_token: window.localStorage.getItem("Authorization"), //交互口令
  stt_messageCount: 0, // 消息角标数值
  stt_casInfo: JSON.parse(reg_obj.test(_cas_info) ? _cas_info : "{}"),
  //logo配置
  stt_logoConfig: JSON.parse(
    window.localStorage.getItem("__LOGO__CONFIG") || _logo_default_config
  ),
  stt_cmsTool: JSON.parse(window.localStorage.getItem("__CMS__TOOL") || "{}"), //后台工具,
  stt_navList: [], //顶部导航菜单
  stt_platformInfo: JSON.parse(
    window.localStorage.getItem("PLATFORM_INFO") || "{}"
  ),
  stt_isEdit: false,
  stt_theme: "",
  stt_approvalType: {
    pending: "dsp",
    launch: "wfq",
    dealed: "ysp",
    copyTo: "cswd",
  },
};
const getters = {
  /* getters 方法命名前缀gtt_
   * 示例：gtt_onClickShow:(state)=>{}
   */
  gtt_userInfo(state) {
    return state.stt_userInfo;
  },
  gtt_token(state) {
    return state.stt_token;
  },
  gtt_authMenu(state) {
    return state.stt_authMenu;
  },
  gtt_cmsTool(state) {
    return state.stt_cmsTool;
  },
  gtt_platformInfo(state) {
    return state.stt_platformInfo;
  },
};
const mutations = {
  /* mutations 方法命名前缀mtt_
   * 示例：mtt_onClickShow(){}
   */
  mtt_configurationt(state, value) {
    state.stt_isEdit = value;
  },
  mtt_noticeShow(state, value) {
    state.stt_noticeShow = parseInt(value);
    window.sessionStorage.setItem("noticeShow", value);
  },
  mtt_noticeParams(state, value) {
    state.stt_noticeParams = value;
  },
  mtt_globalSearchShow(state, value) {
    state.stt_globalSearchShow = value;
  },
  mtt_globalSearchKeyword(state, value) {
    state.stt_globalSearchKeyword = value;
  },
  //用户信息
  mtt_userInfo(state, value) {
    state.stt_userInfo = value;
    window.localStorage.setItem("__USER__INFO", JSON.stringify(value));
  },
  //用户部门
  mtt_userDepartment(state, value) {
    state.stt_userDepartment = value;
    window.localStorage.setItem("__USER__DEPARTMENT", JSON.stringify(value));
  },
  //菜单
  mtt_authMenu(state, value) {
    state.stt_authMenu = value;
    window.localStorage.setItem("__AUTH__MENU", JSON.stringify(value));
  },
  // 存储token
  mtt_setToken(state, token) {
    state.stt_token = token;
    window.localStorage.setItem("Authorization", token);
  },
  // 获取cas
  mtt_casInfo(state, casInfo) {
    state.stt_casInfo = casInfo;
    window.localStorage.setItem("__CAS__INFO", JSON.stringify(casInfo));
  },
  // 存储消息角标数值
  mtt_setMessageCount(state, messageCount) {
    state.stt_messageCount = messageCount;
  },

  //后台工具
  mtt_cmsTool(state, value) {
    state.stt_cmsTool = value;
    window.localStorage.setItem("__CMS__TOOL", JSON.stringify(value));
  },
  // 清除用户、口令、菜单
  mtt_removeUser(state) {
    /*window.localStorage.clear();
    window.sessionStorage.clear();*/
    window.localStorage.removeItem("Authorization");
    window.localStorage.removeItem("__USER__DEPARTMENT");
    window.localStorage.removeItem("__USER__INFO");
    window.localStorage.removeItem("__AUTH__MENU");
    window.localStorage.removeItem("__CMS__TOOL");
    window.localStorage.removeItem("__CAS__INFO");
    window.localStorage.removeItem("globalClickHandler");
    state.stt_token = null;
    state.stt_userInfo = {};
    state.stt_authMenu = [];
    state.stt_cmsTool = {};
    state.stt_casInfo = {};
  },
  // 存储网站配置
  mtt_logoConfig(state, config) {
    state.stt_logoConfig = config;
    window.localStorage.setItem("__LOGO__CONFIG", JSON.stringify(config));
  },
  //清除网站配置
  mtt_removeLogoConfig(state) {
    window.localStorage.removeItem("__LOGO__CONFIG");
  },
  //顶部导航菜单
  mtt_navList(state, value) {
    state.stt_navList = value;
  },
  // 平台信息
  mtt_setPlatformInfo(state, value) {
    state.stt_platformInfo = value;
    window.localStorage.setItem("PLATFORM_INFO", JSON.stringify(value));
  },
  // 清除平台信息
  mtt_removePlatformInfo(state) {
    state.stt_platformInfo = {};
    window.localStorage.removeItem("PLATFORM_INFO");
  },
  mtt_theme(state, value) {
    state.stt_theme = value;
    window.localStorage.setItem("PRIMARY_THEME", value);
  },
  mtt_removeTheme(state) {
    state.stt_theme = "";
    window.localStorage.removeItem("PRIMARY_THEME");
  },
};
const actions = {
  /* actions 方法命名前缀att_
   * 示例：att_onClickShow(){}
   */
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    workflow,
  },
});
